import { createSelector } from 'reselect';

export const certificatesSelector = (state) => state.Certificates;

export const certificatesById = createSelector(
  certificatesSelector,
  (certificates) => certificates.get('byId')
);
